export default __webpack_public_path__ + "static/media/indlogo.d5eca72b.png";